import Card from './src/card.vue'

export default Card
